import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'

import { Layout } from './Layout'

const SubmitInsuranceLayout = ({ children, disableBeforeUnload = false }) => {
  // warn user before leaving that they may lose progress
  useEffect(() => {
    if (disableBeforeUnload) return
    
    const ua = window.navigator.userAgent
    const msie = ua.indexOf('MSIE ')
    const trident = ua.indexOf('Trident/')

    if (msie < 0 && trident < 0) {
      const beforeUnloadHandler = (e) => {
        // Cancel the event
        e.preventDefault() // If you prevent default behavior in Mozilla Firefox prompt will always be shown
        // Chrome requires returnValue to be set
        e.returnValue = ''
      }
      window.addEventListener('beforeunload', beforeUnloadHandler)
      
      return () => {
        window.removeEventListener('beforeunload', beforeUnloadHandler)
      }
    }
  }, [disableBeforeUnload])

  return (
    <Layout>
      <Helmet>
        <title>Verify My Insurance</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <main>{children}</main>
    </Layout>
  )
}

export { SubmitInsuranceLayout }
